export default __webpack_public_path__ + "static/ui-footer-white-logo-bc2c0c3e0d321d49d93c71e4063e525e.svg";